<template lang="pug">
.home
	img.fundo(src="../assets/images/ticker-tape-one.jpg" style="filter: contrast(45%)")
	.coberto
		h1 Sobre Nós
		h2 Nós Somos Pobres
		h3 A Ticker Tape Parade
		a.btn.btn-secondary.btn-lg.mt-3(href='/automotive') Mais Ainda


</template>	

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

export default {
	name: 'Home',
	components: {
		HelloWorld
	}
}
</script>

<style>

@import "../assets/stylings/engines.css";

body, html {
	height: 100%;
	width: auto;
}

.recipiente {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	text-align: center;
}

.raimundo {
	background-image: url("../assets/images/vintage-test-three.jpg") no-repeat center center fixed;
	min-height: 100%;
	min-width: 100%;
	width: 100;
	height: auto;
	position: relative;
	background-size: cover;
	top: 0;
	left: 0;
	filter: contrast(60%);
	background-color: #607d8b;
	background-blend-mode: multiply;
}


</style>